// ReduxChequeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chequeList: [],
};

const ReduxChequeSlice = createSlice({
  name: "cheques",
  initialState,
  reducers: {
    addCheque: (state, action) => {
      state.chequeList.push(action.payload);
    },
    deleteCheque: (state, action) => {
      state.chequeList = state.chequeList.filter(
        (cheque, index) => index !== action.payload
      );
    },
    clearCheque: (state) => {
      state.chequeList = [];
    },
  },
});

export const { addCheque, deleteCheque, clearCheque } =
  ReduxChequeSlice.actions;
export default ReduxChequeSlice.reducer;
